import {
    List,
    ListItem,
    ListItemButton,
    Divider,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttPagination, SttNoResults } from '../all';
import { checkOffTag, formatPriceByLocale } from '../../lib/utils';

type Mship = {
    id: number;
    name: string;
    fullName: string;
    amount?: number;
    amountShape?: {
        currency?: string;
        locale?: string;
    };
    img?: {
        url: string;
    };
    user?: {
        id?: number;
        login: string;
    };
};

type Mships = {
    count: number;
    pages: number;
    rows: Mship[];
};

type Props = {
    mships?: Mships;
    page?: number;
    onSelect: (mship: Mship) => void;
    onLoadMships: (params: { page: number }) => void;
};

/**
 *
 * Params
 *
 *     * Object mships(count,rows)
 *     * integer page=1
 *    * function onSelect(mship)
 *    * function onLoadMships({page})
 */
export function SttMshipList({
    mships,
    page = 1,
    onSelect,
    onLoadMships,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <List>
            {/* --- Searching box --- */}
            {mships?.rows?.map((mship: any) => (
                <div key={mship.id}>
                    <Divider />
                    <ListItemButton onClick={() => onSelect(mship)}>
                        <ListItemAvatar>
                            <Avatar
                                alt={mship.name}
                                src={mship.img ? mship.img.url : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText
                            primary={mship.fullName}
                            secondary={
                                <>
                                    {mship.user &&
                                    checkOffTag(mship.user.login) ? (
                                        <i style={{ color: '#5b5b5b' }}>
                                            {t('user.userCancelled')}
                                        </i>
                                    ) : mship.amount ? (
                                        <>
                                            <span>
                                                {t('payment.purse')}:&nbsp;
                                            </span>
                                            <b>
                                                {formatPriceByLocale(
                                                    mship.amount,
                                                    mship?.amountShape
                                                        ?.currency,
                                                    mship?.amountShape?.locale,
                                                )}
                                            </b>
                                        </>
                                    ) : null}
                                </>
                            }
                        />
                    </ListItemButton>
                </div>
            ))}

            {/* --- No results --- */}
            {mships && mships.count === 0 && (
                <ListItem>
                    <SttNoResults />
                </ListItem>
            )}

            {/* --- List --- */}
            <ListItem>
                {mships && (
                    <Box m="auto">
                        <SttPagination
                            page={page}
                            pages={mships.pages}
                            count={mships.count}
                            onChangePage={(page: number) =>
                                onLoadMships({ page })
                            }
                        />
                    </Box>
                )}
            </ListItem>
        </List>
    );
}
